import { colors } from '@sweep-io/sweep-design';
import { MarkdownWrapper } from '../common/MarkdownWrapper';
import { DataTableVariant } from '../common/table/TableTypes';
import { Box } from '@mui/material';
import { MarkdownWithReply } from '../common/MarkdownWithReply';

const ExpandableIssue = ({
  content,
  onTextSelection,
}: {
  content: string;
  onTextSelection?: (text: string | null) => void;
}) => {
  const markdownWrapperProps = {
    content,
    removeMargins: false,
    color: colors.grey[700],
    dataTableVariant: DataTableVariant.small,
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        sx={{
          pl: 10, //to start under the "name" column of the table
        }}
      >
        <Box maxWidth="680px">
          {onTextSelection ? (
            <MarkdownWithReply
              markdownWrapperProps={markdownWrapperProps}
              onTextSelection={onTextSelection}
            />
          ) : (
            <MarkdownWrapper {...markdownWrapperProps} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ExpandableIssue;
